export const API = '/api';

export const AUTHORIZATION = `${API}/me`;
export const AUTHORIZATION_MODEL = 'authorization';

export const IDENTITY_PROVIDER = `${API}/identity-providers`;
export const IDENTITY_PROVIDER_MODEL = 'identityProvider';
